import React, { useState, useEffect } from 'react';
import { CheckCircle, Award, TrendingUp, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || 'https://aptirix-version-610696728606.asia-south1.run.app/api';

const ProfileCompletionModal = ({ isOpen, onClose }) => {
  const [creditsEarned, setCreditsEarned] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    const fetchCredits = async () => {
      try {
        const res = await fetch(`${API_URL}/credits/service-costs`);
        if (res.ok) {
          const data = await res.json();
          setCreditsEarned(data.profile_completion_credits ?? 100);
        }
      } catch {
        setCreditsEarned(100);
      }
    };
    fetchCredits();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="relative bg-white rounded-xl shadow-xl max-w-sm w-full mx-4 overflow-hidden">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors z-10"
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {/* Content */}
        <div className="p-6 text-center">
          {/* Success Icon */}
          <div className="flex justify-center mb-4">
            <div className="bg-teal-600 rounded-full p-3">
              <CheckCircle size={36} className="text-white" strokeWidth={2.5} />
            </div>
          </div>

          {/* Success Message */}
          <h2 className="text-xl font-bold text-gray-900 mb-1">Profile Created!</h2>
          <p className="text-sm text-gray-600 mb-4">
            Your profile is now live and ready to attract recruiters.
          </p>

          {/* Credits Earned */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
            <div className="flex items-center justify-center gap-2 mb-1">
              <Award className="text-amber-500" size={24} />
              <span className="text-2xl font-bold text-amber-600">
                +{creditsEarned ?? '...'} Credits
              </span>
            </div>
            <p className="text-xs text-amber-700">Welcome bonus for AI interviews, resume tools & more</p>
          </div>

          {/* Next Step */}
          <div className="bg-teal-50 border border-teal-200 rounded-lg p-3 mb-4 text-left">
            <div className="flex items-start gap-2">
              <TrendingUp className="text-teal-600 mt-0.5 flex-shrink-0" size={18} />
              <div>
                <p className="text-sm font-semibold text-teal-900">Next: Verify Your Profile</p>
                <p className="text-xs text-teal-700">
                  Get <span className="font-bold">3x more visibility</span> to recruiters
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <button
            onClick={onClose}
            className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2.5 px-4 rounded-lg transition-colors text-sm"
          >
            Continue to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionModal;
